export const blankClassroom = [
  {
    name: ' member1',
    participantId: false,
    isHandRaised: false,
    isCalledOn: false,
  },
  {
    name: ' member2',
    participantId: false,
    isHandRaised: false,
    isCalledOn: false,
  },
  {
    name: ' member3',
    participantId: false,
    isHandRaised: false,
    isCalledOn: false,
  },
  {
    name: ' member4',
    participantId: false,
    isHandRaised: false,
    isCalledOn: false,
  },
  {
    name: ' member5',
    participantId: false,
    isHandRaised: false,
    isCalledOn: false,
  },
  {
    name: ' member6',
    participantId: false,
    isHandRaised: false,
    isCalledOn: false,
  },
];
